import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Button from '../../BaseComponents/Button';
import { RootState } from '../../../store/store';
import { getTagsList, updateTag } from '../../../api/tags';
import { setTagsList } from '../../../store/appSlice';
import { Tag } from '../../../types/apiGeneratedTypes';
import TagsTabele from './TagTable';
import TagsModal from './TagsModal';
import './TagsTab.scss';

const TagsTab = () => {
  const dispatch = useDispatch();
  const { tagsList } = useSelector((state: RootState) => state.app);

  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [tagToEdit, setTagToEdit] = useState<Tag | null>(null);

  const tagCount = tagsList?.length || 0;

  const refreshTags = async () => {
    const tagsListResp = await getTagsList();
    dispatch(setTagsList(tagsListResp.tags ?? []));
  };

  const handleAdd = () => {
    setTagToEdit(null);
    setIsFormModalOpen(true);
  };

  const handleEdit = (tag: Tag) => {
    setTagToEdit(tag);
    setIsFormModalOpen(true);
  };

  const handleToggleStatus = async (tag: Tag) => {
    if (!tag.id) return;

    const isCurrentlyActive = tag.is_active !== false;

    try {
      await updateTag({
        id: tag.id,
        is_active: !isCurrentlyActive,
      });
      toast.success(
        isCurrentlyActive
          ? 'Tag deactivated successfully'
          : 'Tag activated successfully'
      );
      await refreshTags();
    } catch (error) {
      console.error('Error updating tag status:', error);
      toast.error('Failed to update tag status');
    }
  };

  const handleSaved = async () => {
    setIsFormModalOpen(false);
    setTagToEdit(null);
    await refreshTags();
  };

  return (
    <div className='tags-tab'>
      <div className='search-row-container'>
        <div className='search-and-filter-container'>
          <div className='count-container'>
           {tagCount} {tagCount === 1 ? `Tag` : `Tags`}
          </div>
        </div>
        <Button
          isSecondary={true}
          text='Add Tag'
          onClick={handleAdd}
        />
      </div>
      <TagsTabele onEdit={handleEdit} onToggleStatus={handleToggleStatus} />
      <TagsModal
        isOpen={isFormModalOpen}
        tagToEdit={tagToEdit}
        onClose={() => {
          setIsFormModalOpen(false);
          setTagToEdit(null);
        }}
        onSaved={handleSaved}
      />
    </div>
  );
};

export default TagsTab;
